import { Maschine } from '@/modules/ewerp/models/MaschinenModels';

export type State = {
  maschinen: Array<Maschine>;
};

export const state: State = {
  maschinen:
    sessionStorage.getItem('maschinen') != null && sessionStorage.getItem('maschinen') !== undefined
      ? JSON.parse(sessionStorage.maschinen)
      : new Array<Maschine>(),
};
